import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"
import { useEffect, useMemo, useState } from "preact/hooks";
import { formatShopifyMoney, getHandle, calculateDiscount, fetchProductData, addToCart } from "../helpers"

export default function Product({ product }) {
    const [ prices, setPrices ] = useState({
        price: product.price,
        listPrice: product.listPrice || null
    });
    const [skusWithMetafields, setSkusWithMetafields] = useState([]);

    useEffect(() => {
        fetchProductData(product?.productId).then(data => {
            const product = data?.data?.products?.edges?.[0]?.node;
            if(!product) return;
            const variants = product.variants?.edges;
            const skusWithMetafields = variants?.map(variant => {
                return {
                    id: variant?.node?.id?.split('/')[4],
                    metafield: variant?.node?.metafield
                }
            });
            setSkusWithMetafields(skusWithMetafields);

            if(window.Shopify?.country !== 'US') {
                const price = product.priceRange?.minVariantPrice?.amount;
                const listPrice = product.compareAtPriceRange?.minVariantPrice?.amount;
                setPrices({ price, listPrice })
            }
        })
    }, [])
    
    const isFinalSale = useMemo(() => product.tags1?.includes("FINAL SALE"), []);
    const isLaborDaySale = useMemo(() => product.tags1?.includes("30% off w/ code LDW"), []);

    //console.log('skusWithMetafields', skusWithMetafields);

    return (
        <SerpElement
            as="li"
            hit={product}
            class="grid__item anim-in animated fadeInUp inview"
        >
            <div data-available="true" data-time-ago="" data-style-type="Nick+Top" data-product-id={product.productId} class="card-wrapper relative ">
                <a href={product.url} class="full-unstyled-link link--fill-parent">
                <span class="visually-hidden">{product.name}</span>
                </a>
                <div class="card card--product " tabindex="-1" data-title={product.name}>
                    <div class="card__inner">
                        <div class="relative ">
                        <div class="media media--transparent media--adapt media--hover-effect lazyImage" style="padding-bottom: 150.00000000000003%;">
                            <div style="padding-top:150.00000000000003%;" class="image-element lazyImage" data-image-loading-animation="">
                                <img 
                                src={`${product.imageUrl}&width=800`}
                                loading="lazy" alt={product.name} />
                            </div>
                            <div class="product-card__hover" style="opacity: 0;visibility: hidden;">
                                <div style="padding-top:150.00000000000003%;" class="image-element lazyImage" data-image-loading-animation="">
                                <img 
                                src={`${product.alternateImageUrls[0]}&width=800`}
                                loading="lazy" alt={product.name} />
                                </div>
                            </div>
                        </div>
                        </div>
                        {product.categories?.includes("Sweet Shop") && 
                            <div class="card__badge card__badge--top-right" data-this-badge="">
                                <a class="badge badge--sweet-shop" href="/collections/swimwear/badge:sweet-shop"> 
                                    <img src="//frankiesbikinis.com/cdn/shop/files/Logo_Blue.png?height=40&amp;v=1714672220" alt="" height="14" />
                                </a>
                            </div>
                        }
                        <div class="card__badge card__badge--bottom-right" data-this-badge="">
                            {isFinalSale && 
                                <a 
                                    class="badge badge--final-sale p-[1px_.5rem] rounded-[0.3rem]  text-[11px] bg-white" 
                                    href="/collections/final-sale"
                                >
                                    Final Sale
                                </a>
                            }
                            {isLaborDaySale && 
                                <a 
                                    class="badge badge--30-off-w-code-ldw p-[1px_.5rem] rounded-[0.3rem]  text-[11px] bg-white" 
                                    href="/collections/30-off-w-code-ldw"
                                >
                                    30% off w/ code LDW
                                </a>
                            }
                        </div>
                        <div class="quick-add-bar ">
                        <div class="quick-add-bar__inner">
                            <form id={`quick-add-form--${product.productId}`} action="/" class="quick-add-bar__form" aria-hidden="true">
                                <fieldset class="js product-form__input" data-option="Size">
                                    <legend class="form__label">Size</legend>
                                    {product.skus?.map((sku, index) => {
                                        if (sku.availability == "InStock") {
                                            return (
                                            <div 
                                                class="quick-add__radio nosto-input" 
                                                nosto-id={product.productId} 
                                                nosto-sku={sku.id}
                                            > 
                                                <input 
                                                    type="radio" 
                                                    value={sku.name} 
                                                    tabindex="-1"
                                                /> 
                                                <label 
                                                    for={`qa-${getHandle(product.url)}-Size-${index}`} 
                                                    onClick={addToCart} 
                                                    class={`${isFinalSale ? 'ns-final-sale' : ''}`}
                                                > 
                                                    {sku?.customFields?.filter(field => field.key == "size")[0]?.value} 
                                                </label> 
                                                    {
                                                        skusWithMetafields?.some(obj => obj?.id === sku?.id) && 
                                                        skusWithMetafields?.find(obj => obj?.id === sku?.id)?.metafield ? 
                                                            <input 
                                                                class="product-input__property" 
                                                                data-name="Note" 
                                                                type="hidden" 
                                                                name="properties[Note]" 
                                                                value={skusWithMetafields?.find(obj => obj?.id === sku?.id)?.metafield?.value}
                                                            /> 
                                                        : ""
                                                    } 
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div 
                                                    class="quick-add__radio nosto-input ns-disabled" 
                                                    nosto-id={product.productId} 
                                                    nosto-sku={sku.id}
                                                > 
                                                    <input 
                                                        type="radio" 
                                                        value={sku.name} 
                                                        tabindex="-1" 
                                                        disabled
                                                    /> 
                                                    <label 
                                                        for={`qa-${getHandle(product.url)}-Size-${index}`}
                                                    > 
                                                            {sku?.customFields?.filter(field => field.key == "size")[0]?.value} 
                                                    </label> 
                                                </div>
                                            )
                                        }
                                    })}
                                </fieldset>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-information">
                    <div class="card-information__left">
                        <span class="card-information__text">
                        {product.name.includes("-") && product.name.split("-").shift()}
                        {!product.name.includes("-") && product.name}
                        </span>
                        <div class="card__colors-promo flex">
                        <div class="card__colors-wrapper">
                            {/* <div class="total-colors">2 Colors</div> */}
                        </div>
                        </div>
                    </div>
                    
                    {(prices.price == prices.listPrice || prices.listPrice <= 0) ?
                        <div class="card-information__right">
                            <div class="price ">
                                <div class="price__regular">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <span class="price-item price-item--regular"
                                        dangerouslySetInnerHTML={{
                                            __html: formatShopifyMoney(prices.price) 
                                        }}
                                    />
                                </div>
                                <div class="price__sale">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <s class="price-item price-item--regular">
                                    </s>
                                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                    <span 
                                        class="price-item price-item--sale" 
                                        dangerouslySetInnerHTML={{ 
                                            __html: formatShopifyMoney(prices.price) 
                                        }}
                                    />
                                </div>
                                <small class="unit-price caption hidden">
                                    <dt class="visually-hidden">Unit price</dt>
                                    <dd>
                                        <span></span>
                                        <span aria-hidden="true">/</span>
                                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                        <span>
                                        </span>
                                    </dd>
                                </small>
                            </div>
                        </div> : 
                        <div class="card-information__right">
                            <div class="price  price--on-sale ">
                                <div class="price__regular">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <span class="price-item price-item--regular"
                                        dangerouslySetInnerHTML={{ 
                                            __html: formatShopifyMoney(prices.price) 
                                        }}
                                    />
                                </div>
                                <div class="price__sale">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <s class="price-item price-item--regular"
                                        dangerouslySetInnerHTML={{ 
                                            __html: formatShopifyMoney(prices.listPrice) 
                                        }}
                                    />
                                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                    <span class="price-item price-item--sale"
                                        dangerouslySetInnerHTML={{ 
                                            __html: formatShopifyMoney(prices.price) 
                                        }}
                                    />
                                </div>
                                <small class="unit-price caption hidden">
                                    <dt class="visually-hidden">Unit price</dt>
                                    <dd>
                                        <span></span>
                                        <span aria-hidden="true">/</span>
                                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                        <span>
                                        </span>
                                    </dd>
                                </small>
                            </div>
                            <div class="card__percentage-off">
                                {calculateDiscount(prices.price, prices.listPrice)}% off
                            </div>
                        </div>
                        }
                    </div>
                <div class="card__badge-mobile medium-up-hide">
                </div>
            </div>
        </SerpElement>
    )
}
